import { Inventaire } from "@repo/types";
import { type ClassValue, clsx } from "clsx";
import { format } from "date-fns";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isNotNullOrEmpty(value: any): boolean {
  return value !== null && value !== undefined && value !== '' && value !== 'null';
}


/**
 * Format a date to a readable string
 */
export function formatDate(date: Date): string {
  if (!date) return format(new Date(), 'dd/MM/yyyy');
  try {
    return format(date, 'dd/MM/yyyy');
  } catch (error) {
    console.error("Error formatting date:", error);
    return format(new Date(), 'dd/MM/yyyy');
  }

}

export function formatDateOnly(date: Date): string {

  try {
    const formatter = new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);

    return formatter;
  } catch (error) {
    console.error("Error formatting date:", error);
    return date.toString();
  }
}


/**
 * Get the base URL for static assets
 * In Vite, uses import.meta.env.BASE_URL if available
 * In Next.js, uses empty string (assets are at root)
 * Falls back to empty string if not available
 */
function getBaseUrl(): string {
  // Check if we're in a Vite environment
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    // Vite provides BASE_URL for base path configuration
    // Use type assertion to avoid TypeScript errors
    const env = import.meta.env as { BASE_URL?: string };
    return env.BASE_URL || '';
  }
  // Next.js or other environments - assets are at root
  return '';
}

/**
 * Get the path to a marker icon image
 * In Vite/Next.js, files in public/ are served from the root
 * So /images/markers/... resolves to public/images/markers/...
 * 
 * @param filename - The filename of the marker icon (e.g., 'Draft.svg')
 * @returns The full path to the marker icon
 */
function getMarkerIconPath(filename: string): string {
  const baseUrl = getBaseUrl();
  // Remove trailing slash from baseUrl if present, and ensure leading slash
  const cleanBaseUrl = baseUrl.replace(/\/$/, '');
  return `${cleanBaseUrl}/images/markers/${filename}`;
}

/**
 * Render the appropriate icon for an inventaire
 * @param inventaire - The inventaire object
 * @returns Path to the marker icon image
 */
export function renderIcon(inventaire: Inventaire): string {

  if (inventaire?.type?.toUpperCase() === "ARBRE") {
    if (inventaire?.arbre?.is_alert) {
      return getMarkerIconPath('EnAlignementAlert.svg');
    }
    return inventaire.is_finished ? getMarkerIconPath('Original.svg') : getMarkerIconPath('Draft.svg');
  }
  if (inventaire?.type?.toUpperCase() === "ALIGNEMENT") {
    if (inventaire?.arbre?.is_alert) {
      return getMarkerIconPath('EnAlignementAlert.svg');
    }
    return inventaire.is_finished ? getMarkerIconPath('EnAlignement.svg') : getMarkerIconPath('Draft.svg');;
  }
  return getMarkerIconPath('Original.svg');
}
export const isBetweenDates = (date: Date, startDate: Date, endDate: Date): boolean => {
  return date.getTime() >= startDate.getTime() && date.getTime() <= endDate.getTime();
}